var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMokxWhiteLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 312.53 257.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M124.93,243.68c1.33,7.53,4.53,13.27,11.22,12.92v.44c-8.13,2.44-16.14-1.96-18.37-13.35l-2.15-12.67-8.17,14.21s-1.62,2.69-1.68,4.81h-.41l-10.8-20.55-2.14,17.41c-.12.98.81,1.86,1.7,1.86h.68v.41h-9.09v-.44h.69c1.5,0,2.83-.93,3.15-2.54l2.95-20.72c-2.2-3.93-6.2-9.65-10.96-9.21l-.09-.44c7.94-3.36,13.97,2.07,17.23,7.67l8.68,16.32,12.61-21.7h.4l4.55,25.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M164.42,233.93c0,9.77-6.85,15.83-17.54,15.83s-17.54-6.06-17.54-15.83,6.85-15.83,17.54-15.83,17.54,6.06,17.54,15.83ZM157.27,233.93c0-8.64-4.01-14-10.39-14s-10.39,5.36-10.39,14,4.01,14,10.39,14,10.39-5.36,10.39-14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M176.78,245.99c.03,1.52,1.26,2.73,2.79,2.73h.55v.44s-13.21,0-13.21,0v-.44h.56c1.52,0,2.76-1.22,2.79-2.73v-24.13c-.04-1.51-1.27-2.72-2.78-2.72h-.55v-.44s13.2,0,13.2,0v.44h-.56c-1.51,0-2.74,1.21-2.79,2.71v24.14ZM194.45,246.02c1.32,1.76,2.67,2.65,4.43,2.69v.43h-3.58c-1.23,0-6.51.09-9.35-3.6-.83-1.12-7.78-10.68-7.78-10.74l10.33-13.64c.73-.97.17-2.07-1.03-2.07h-.42v-.38h9.98v.39h-.19c-1.9,0-3.62.83-4.74,2.1l-8.46,10.04,10.82,14.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M230.86,249.16h-14.83v-.44s.54,0,.54,0c1.18,0,2.23-1.44,1.5-2.67l-6.09-9.45-6.39,9.42c-.81,1.23.34,2.7,1.53,2.7h.55v.43s-10.74,0-10.74,0v-.43h.61c1.78,0,3.31-1.15,4.3-2.46l8.57-12.11-8.03-12.46c-.91-1.34-2.58-2.56-4.4-2.56h-.62v-.43h14.77v.43s-.54,0-.54,0c-1.18,0-2.22,1.44-1.51,2.67l5.43,8.38,5.33-8.36c.74-1.23-.32-2.7-1.51-2.7h-.55v-.44s10.68,0,10.68,0v.44s-.6,0-.6,0c-1.81,0-3.4,1.2-4.34,2.53l-7.41,10.99,8.75,13.52c.91,1.34,2.58,2.54,4.41,2.54h.59v.44Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M273.53,115.23l-3.24-4.01c-31.99-.9-79.7,7.89-130.11,23.36C52.74,161.41,0,197.73,0,197.73c0,0,76.24-47.19,178.06-69.51,46.87-10.27,76.3-13.68,95.47-12.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M270.29,111.22l3.24,4.01c22.48.8,30.85,7.23,36.62,14.83-1.38-12.29-16.39-18.17-39.87-18.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,0s9.83,2.71,25.43,6.95C9.78,2.66,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M240.32,70.28C213.55,59.06,81.63,22.4,25.43,6.95,9.83,2.71,0,0,0,0l258.48,96.62,24.74-6.64c-12.69-7.44-28.21-13.55-42.9-19.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M283.22,89.98l-24.74,6.64,11.81,14.6c23.48.66,38.49,6.54,39.87,18.84,1.84-17.9-10.04-30.17-26.93-40.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M283.22,89.98l5.35-1.44c-21.87-14.51-57.41-28.22-115.09-42.58C125.75,34.09,60.77,16.57,25.43,6.95c56.2,15.44,188.12,52.11,214.89,63.32,14.69,6.15,30.21,12.26,42.9,19.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M299.76,97.03c-3.26-2.87-6.98-5.69-11.19-8.49l-5.35,1.44c16.89,9.9,28.77,22.17,26.93,40.07,0,0,9.78-15.29-10.4-33.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M208.23,101.16c20.64,0,27.01-6.78,27.01-6.78,0,0-10.6,5.3-22.22,2.24-11.62-3.06-16.92-11.82-16.92-11.82l-14.79-4.17s6.28,20.53,26.92,20.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M258.48,96.62l-23.24-2.24s-6.54,9.03-28.4,9.03-30.87-24.29-30.87-24.29h0l-10.24-2.89s-6.32,27.52,25.68,35.67c0,0-29.56,9.38-38.53-20.38l-66.05,36.28,40.77-9.17S50.96,158.39,0,197.73c0,0,52.74-36.32,140.17-63.15,50.42-15.47,98.13-24.26,130.11-23.36l-11.81-14.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M206.84,103.41c21.86,0,28.4-9.03,28.4-9.03,0,0-6.37,6.78-27.01,6.78s-26.92-20.53-26.92-20.53l-5.34-1.5h0s9.01,24.29,30.87,24.29Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "267.78 97.23 263.1 98.15 266.98 100.69 275.48 100.69 267.78 97.23"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMokxWhiteLogo);
export default __webpack_public_path__ + "static/media/mokx-white-logo.fb0e1ffe4d47a42f9245193c017ffc72.svg";
export { ForwardRef as ReactComponent };